import { telephoneLisible, type ChampCoordonneeCv, type CoordonneesCv } from '@rh/shared';

/** « Lu dans le CV : 98 765 432 · nom@exemple.tn » */
export function CoordonneesLues({ coordonnees }: { coordonnees: CoordonneesCv }) {
  const valeurs = [...coordonnees.telephones.map(telephoneLisible), ...coordonnees.emails];
  return (
    <p className="coordonnees-lues">
      {valeurs.length === 0 ? 'Aucun téléphone ni e-mail lu dans le CV.' : `Lu dans le CV : ${valeurs.join(' · ')}`}
    </p>
  );
}

interface Props {
  coordonnees: CoordonneesCv;
  telephoneFiche: string | null;
  emailFiche: string | null;
  envoi: boolean;
  onAjouter: (champ: ChampCoordonneeCv, valeur: string) => void;
}

/**
 * « Téléphone lu dans le CV : … — Ajouter » : la fiche ne se complète que sur un
 * clic, et seulement pour une coordonnée qu'elle n'a pas encore — jamais
 * par-dessus une coordonnée existante (arbitrage du 2026-09-15).
 */
export function PropositionsCoordonnees({ coordonnees, telephoneFiche, emailFiche, envoi, onAjouter }: Props) {
  const propositions = [
    ...(telephoneFiche
      ? []
      : coordonnees.telephones.map((valeur) => ({
          champ: 'telephone' as const,
          valeur,
          libelle: `Téléphone lu dans le CV : ${telephoneLisible(valeur)}`,
        }))),
    ...(emailFiche
      ? []
      : coordonnees.emails.map((valeur) => ({
          champ: 'email' as const,
          valeur,
          libelle: `E-mail lu dans le CV : ${valeur}`,
        }))),
  ];
  if (propositions.length === 0) return null;

  return (
    <ul className="propositions-coordonnees">
      {propositions.map((proposition) => (
        <li key={`${proposition.champ}-${proposition.valeur}`}>
          <span>{proposition.libelle}</span>
          <button
            type="button"
            className="bouton-second"
            disabled={envoi}
            aria-label={`Ajouter à la fiche — ${proposition.libelle}`}
            onClick={() => onAjouter(proposition.champ, proposition.valeur)}
          >
            Ajouter
          </button>
        </li>
      ))}
    </ul>
  );
}
